/**
 * @file
 * A JavaScript file for the Staywell Anchor Navigation.
 *
 * @copyright Copyright 2025 MERGE
 */

(function ($) {
    let staywellArticle = document.getElementById('divDisplayStaywellArticle');
    if (staywellArticle) {
        let sections = staywellArticle.querySelectorAll('.outputBody section');
        if (sections.length > 0) {
            console.log('init anchor nav');
            staywellArticle.querySelector('.outputBody').classList.add('anchor-main', 'accordion--mob-only');
            staywellArticle.querySelector('.outputBody').setAttribute('data-accordion-section', 'anchor-content')
            staywellArticle.querySelector('.outputBody').setAttribute('data-accordion-title', 'anchor-content__heading')
            staywellArticle.querySelector('.outputBody').setAttribute('data-accordion-content', 'anchor-content__content');
            sections.forEach((section, idx) => {
                idx++;
                section.classList.add('anchor-content');
                section.querySelector('h2').classList.add('anchor-content__heading');
                section.querySelector('h2').setAttribute('id', 'scroll-nav__'+idx);
                let h2 = section.querySelector('h2');
                section.querySelector('h2').remove();
                let content = section.innerHTML;
                section.innerHTML = h2.outerHTML+'<div class="anchor-content__content">'+content+'</div>';
            });
        } else {
            // If properly formatted article not found, remove anchor nav functionaity.
            console.log('proper article format not found, anchor nav disabled.');
            document.querySelector('.anchor-navigation').classList.remove('anchor-navigation');
            document.querySelector('.grid--minor-major').classList.remove('grid--minor-major');
            document.querySelector('.l-minor-major--1').remove();
        }
    }
}(jQuery));